import { put, takeLatest, select, call } from 'redux-saga/effects';

import filter from 'lodash/filter';

import { formatError } from '../../../libs';
import checkoutAPI from '../../api/checkout';
import { Types, Creators as CreditCardCreators } from '../../reducers/creditCard';
import { getCookie } from '../../utils/cookies';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* getInstallment({ value, isTotem = false }) {
  try {
    const { creditCard, app } = yield select(getState);
    const token = yield select(getToken);
    const domain = app.getIn(['config', 'domain']);
    const cartId = yield select(getCookie, { name: 'cart.id', domain });
    const siteId = app.getIn(['config', 'siteId']);
    const creditCards = creditCard.getIn(['creditCards']);
    const quantityCreditCards = Object.keys(creditCards).length;
    const totalValueOrder = creditCard.getIn(['totalValueOrder']);
    const updatedCreditCard = { ...creditCard.getIn(['creditCard']) };
    const result = {
      creditCards: { ...creditCard.getIn(['creditCards']) },
      creditCard: creditCard.getIn(['creditCard']),
      totalPending: 0,
    };

    if (!isTotem) {
      let [installment, remaining] = [null, null];

      if (value > 0 && value <= totalValueOrder && quantityCreditCards > 1) {
        [installment, remaining] = yield call(checkoutAPI.getPaymentTypes, cartId, { valor: value }, token, siteId);
      } else {
        const formasPagamento = yield call(checkoutAPI.getPaymentTypes, cartId, {}, token, siteId);
        installment = formasPagamento.find((formaPagamento) => formaPagamento.formaPagamento === 'CC');
      }

      if (installment) {
        updatedCreditCard.installment = installment || updatedCreditCard.installment;
        updatedCreditCard.valor = installment ? installment.valorTotal : Number(value.toFixed(2));

        if (quantityCreditCards === 2) {
          const otherSequence = updatedCreditCard.sequencia === 1 ? 2 : 1;
          const updateOtherCreditCard = { ...creditCards.getIn([otherSequence]) };

          updateOtherCreditCard.installment = remaining || updateOtherCreditCard.installment;
          updateOtherCreditCard.valor = remaining ? remaining.valorTotal : totalValueOrder - updatedCreditCard.valor;

          result.creditCards = { [otherSequence]: updateOtherCreditCard };
          result.totalPending += updateOtherCreditCard.valor;
        }

        result.totalPending = totalValueOrder - Number((updatedCreditCard.valor + result.totalPending).toFixed(2));
      } else {
        updatedCreditCard.valor = value > totalValueOrder ? updatedCreditCard.valor : value;

        if (value === 0) {
          updatedCreditCard.parcela = '';
          updatedCreditCard.installment = { parcelas: [] };
        }
      }

      if (quantityCreditCards > 2 || !installment) {
        result.totalPending =
          totalValueOrder -
          Number(
            (
              value +
              filter(
                creditCards,
                ({ sequencia }) => sequencia !== creditCard.getIn(['creditCard', 'sequencia'])
              ).reduce((acc, item) => acc + parseFloat(item.valor || 0), 0)
            ).toFixed(2)
          );
      }

      updatedCreditCard.updateAt = new Date().getTime();
      result.creditCard = updatedCreditCard;
    }

    yield put(CreditCardCreators.updateCreditCardSuccess({ ...result }));
  } catch (error) {
    yield put(CreditCardCreators.getInstallmentError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_INSTALLMENT_REQUEST, getInstallment);
}
